const nestedSort = (
  data: Array<any>,
  includedRows: Array<any>,
  relationalFieldName: string,
) => {
  const dataMap = new Map<string | number, any>()

  let isCompletelyFlatArray : boolean = true

  const updateDataMap = () => {
    data.forEach((item) => {
      dataMap.set(item[relationalFieldName], { ...item, nestedItems: [] })

      if ('parent_id' in item) {
        isCompletelyFlatArray = false
      }
    })

    includedRows.forEach((row) => {
      const id = row[relationalFieldName]
      if (!dataMap.has(id)) {
        dataMap.set(id, {
          ...row,
          greyOutIncluded: true,
          order: null,
          nestedItems: [],
        })
      }
    })
  }

  updateDataMap()

  dataMap.forEach((item) => {
    const parent = dataMap.get(item.parent_id)
    if (parent) {
      parent.nestedItems.push(item)
    }
  })

  const roots = Array.from(dataMap.values()).filter(
    (item) => item.parent_id === null || item.parent_id === undefined
  )
  const finalArr: Array<any> = []

  const flattenAndSort = (item: any, level: number = 0) => {
    if (
  item.greyOutIncluded === true &&
  item.nestedItems.length === 0 &&
  !includedRows.some((i) => i[relationalFieldName] === item[relationalFieldName])
) {
  return
}

    item.level = level


    if (!finalArr.some((i) => i[relationalFieldName] === item[relationalFieldName])) {
      if(item.greyOutIncluded && isCompletelyFlatArray){
        //do not add grey out items to flat arrays (array without parent items)
      } else {
        finalArr.push(item)
      }
    }

    item.nestedItems
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base',
        }),
      )
      .forEach((child) => flattenAndSort(child, level + 1))
  }

  roots
  .sort((a, b) =>
    a.name.localeCompare(b.name, undefined, {
      numeric: true,
      sensitivity: 'base',
    }),
  )
  .forEach((root) => {
    const isExplicitlyIncluded = includedRows.some(
      (i) =>
        i[relationalFieldName] ===
        root[relationalFieldName]
    )

    if (!root.greyOutIncluded || root.nestedItems.length > 0 || isExplicitlyIncluded) {
      flattenAndSort(root, 0)
    }
  })
    

  return finalArr
}

export default nestedSort